/**
 * Formats a phone number string to (###) ###-#### display format
 * @param value - Raw phone number string (can contain any characters)
 * @returns Formatted phone string or empty string
 */
export const formatPhoneNumber = (value: string): string => {
  // Strip all non-digits
  const digits = value.replace(/\D/g, '')
  // Return empty if no digits
  if (!digits) return ''
  // Format based on length
  if (digits.length <= 3) {
    return `(${digits}`
  } else if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  } else {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`
  }
}
/**
 * Normalizes a phone number to digits-only for storage
 * @param value - Formatted or unformatted phone string
 * @returns Digits-only string (e.g., "5551234567")
 */
export const normalizePhoneNumber = (value: string): string => {
  return value.replace(/\D/g, '')
}
/**
 * Gets the cursor position after formatting
 * Maintains cursor position relative to digits, not formatting characters
 */
export const getFormattedCursorPosition = (
  oldValue: string,
  newValue: string,
  oldCursor: number,
): number => {
  // Count digits before cursor in old value
  const digitsBeforeCursor = oldValue
    .slice(0, oldCursor)
    .replace(/\D/g, '').length
  // Find position in new value that has same number of digits before it
  let digitCount = 0
  for (let i = 0; i < newValue.length; i++) {
    if (/\d/.test(newValue[i])) {
      digitCount++
    }
    if (digitCount === digitsBeforeCursor) {
      return i + 1
    }
  }
  return newValue.length
}
